import { useState, useEffect } from 'react';
import { OptionalServices } from '../models/app';
import { getToken } from '../services/GetToken';
import { GetAdditionalServices } from '../services/GetAdditionalServices';
import { useSelector } from 'react-redux';
import { RootState } from '../store/ducks';

export const useGetAdditionalServices = (itemID: string, quantity: string, CustomerId: string) => {
  const [optionalServices, setOptionalServices] = useState<OptionalServices[]>([]);
  const [optionalServicesLoading, setLoading] = useState(true);
  const [optionalServicesError, setError] = useState<string | null>(null);
  const user = useSelector((state: RootState) => state?.store?.user);
    const selectedLocation = useSelector(
      (state: RootState) => state?.store?.selectedLocation
    );
  useEffect(() => {
    // console.log(itemID);
    const fetchOptionalServices = async (itemID: string, quantity: string, CustomerId: string) => {
        try {
          setLoading(true);
          
        var isCustom = false;

        var hasShowAdditionalServices = false;
        if((user !== "") && (user !== "guest")){
          if(localStorage.getItem("customeruserSystemId")!="" && localStorage.getItem("customeruserSystemId")!=null){
            hasShowAdditionalServices = user.subcustomers
            ?.find((sub: any) => sub.Id === localStorage.getItem("customeruserSystemId"))
            ?.ShowAdditionalServices === true;
          }
          else{
            hasShowAdditionalServices = user.ShowAdditionalServices
          }
        }
       


          if (user !== "" && user !== "guest" && hasShowAdditionalServices === false) {
            isCustom = true;
          }
          const apiResponse:any = await GetAdditionalServices( itemID, quantity, CustomerId,isCustom);
          setOptionalServices(apiResponse?.Data);
      
        } catch (error) {
            // console.log(error);
          setError('Error fetching data');
        } finally {
          setLoading(false);
        }
      };

    fetchOptionalServices( itemID, quantity, selectedLocation.guestCutomerId);
  },[]);



  return { optionalServices, optionalServicesLoading, optionalServicesError };
};
